import { faKey, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC } from 'react'
import { Button, Col, Form, FormControl, InputGroup, Row, Spinner } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { Redirect, useRouteMatch } from 'react-router-dom'
import AuthenticationContext from '../Authentication/AppContext'
import LoginService from '../service/LoginService'
import ErrorMessage, { closeErrorAlert } from '../utils/ErrorMessage'
import { validateLoginForm } from '../utils/Helpers'

export const Login: FC<{}> = () => {
  const { auth, refreshAuthentication, refreshUserDetails } = React.useContext(AuthenticationContext)
  const [userName, setUserName] = React.useState('')
  const [userPassword, setUserPassword] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [autoLoginFinished, setAutoLoginFinished] = React.useState(false)
  const [error, setError] = React.useState(null as any)
  const [showError, setShowError] = React.useState(false)
  const { t } = useTranslation()
  const match = useRouteMatch()

  if (auth) {
    return match.path === '/login' ? <Redirect to='/' /> : <></>
  } else if (!autoLoginFinished) {
    LoginService.tryAutoLogin(setAutoLoginFinished, refreshAuthentication, refreshUserDetails)
  }

  return (
    <>
      <Helmet>
        <title>Gateway [{t('login')}]</title>
      </Helmet>
      {autoLoginFinished && (
        <Col md='8' className='p-5 mx-auto'>
          <Form
            className='form-signin'
            onSubmit={(e: any) => {
              e.preventDefault()
              if (validateLoginForm(userName, userPassword, setError, setShowError)) {
                LoginService.login(userName, userPassword, setError, setShowError, setLoading, refreshAuthentication, refreshUserDetails)
              }
            }}>
            <h1 className='text-center'>{t('login')}</h1>

            <InputGroup className='mb-3'>
              <InputGroup.Prepend>
                <InputGroup.Text id='Username-addon1'>
                  <FontAwesomeIcon icon={faUser} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                placeholder={t('username.text')}
                aria-label='Username'
                aria-describedby='Username-addon1'
                autoComplete='username'
                value={userName}
                onChange={(e: any) => setUserName(e.target.value)}
              />
            </InputGroup>

            <InputGroup className='mb-4'>
              <InputGroup.Prepend>
                <InputGroup.Text id='Password-addon1'>
                  <FontAwesomeIcon icon={faKey} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                type={t('password.text')}
                placeholder={t('password.text')}
                aria-label='Password'
                aria-describedby='Password-addon1'
                autoComplete='current-password'
                value={userPassword}
                onChange={(e: any) => setUserPassword(e.target.value)}
              />
            </InputGroup>

            <Row>
              <Col>
                <Button type='submit' disabled={loading} block={true}>
                  {loading ? (
                    <>
                      <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' />
                      <span className='ml-1'>{t('loading')}</span>
                    </>
                  ) : (
                    t('signin')
                  )}
                </Button>
              </Col>
            </Row>
            <Row>
              <Col>
                <ErrorMessage error={error} show={showError} onClose={closeErrorAlert(setError, setShowError)} />
              </Col>
            </Row>
          </Form>
        </Col>
      )}
    </>
  )
}
